export const overlayContainer = {
  // background: "rgba(117, 88, 88, 0.25)",
  backgroundColor: '#E7E6E6',
  position: 'absolute',
  overflow: 'hidden',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  'z-index': '9999',
  top: '0',
  left: '0',
  // overflowX: "hidden",
  overflowY: 'moz-scrollbars-vertical',
  // overflowY: "auto",
  // overflowX: "hidden",
  // overflowY: "hidden", // hide vertical
  // overflowX: "auto", // hide horizontal
};

export const welcomeLoader = {
  fontFamily: 'poppins',
  fontSize: '48px',
  fontWeight: 300,
  color: '#6C2AD2',
};

export const welcomeBackLoader = {
  fontFamily: 'poppins',
  fontSize: '48px',
  fontWeight: 700,
  color: '#8651D9',
};
